import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import AppContextProvider from './context';
import AppAuthenticationContextProvider from './context/authentication';
import AppDialogContextProvider from './context/dialogContext';
import AppView3DContextProvider from './context/context3D';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <FluentProvider theme={webLightTheme} applyStylesToPortals>
      <AppAuthenticationContextProvider>
        <AppContextProvider>
          <AppDialogContextProvider>
            <AppView3DContextProvider>
              <App />
            </AppView3DContextProvider>
          </AppDialogContextProvider>
        </AppContextProvider>
      </AppAuthenticationContextProvider>
    </FluentProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
